import React, { useContext } from "react";
import { Context } from "../context/ProductsProvider";

const Preview = () => {
    const { state } = useContext(Context);
    const { inputs: { path } } = state;

    return (
        path && (
        <div
            className="rounded p-1 m-5"
            style={{
            width: "300px",
            height: "300px",
            backgroundImage: `url(${path})`,
            backgroundSize: "cover",
            }}
        ></div>
        )
    );
};

export default Preview;